import { render, staticRenderFns } from "./EleDataChart.vue?vue&type=template&id=2a72880e&scoped=true"
import script from "./EleDataChart.vue?vue&type=script&lang=js"
export * from "./EleDataChart.vue?vue&type=script&lang=js"
import style0 from "./EleDataChart.vue?vue&type=style&index=0&id=2a72880e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72880e",
  null
  
)

export default component.exports